@if (category(); as c) {
    <div
        cdkDrag
        cdkDragPreviewClass="shadow-xl"
        class="p-4 flex w-full items-center select-none gap-3"
    >
        @if (c.centerId) {
            <div
                cdkDragHandle
                class="cursor-move visible flex justify-center items-center bg-gray-50 rounded-full"
            >
                <app-icon
                    name="material-symbols:menu-rounded"
                    class="!size-5 text-gray-400"
                />
            </div>
        }
        <div class="flex w-full items-center justify-between">
            @if (isUpdate()) {
                <div class="flex gap-3 items-center w-full">
                    <app-input
                        class="w-full"
                        [(value)]="value"
                        placeholder="카테고리 명을 입력해주세요."
                    />
                    <app-button
                        variant="outline"
                        color="gray"
                        (click)="handleCancel()"
                        >취소</app-button
                    >
                    <app-button [disabled]="!value()" (click)="submit()"
                        >수정</app-button
                    >
                </div>
            } @else {
                <div class="flex gap-3 items-center">
                    @if (!c.centerId) {
                        <app-badge variant="outline" rounded="xl"
                            >기본</app-badge
                        >
                    }
                    <p class="text-gray-400 text-sm">
                        {{ c.name }} ({{ c.templateCount | number }})
                    </p>
                </div>

                @if (c.centerId) {
                    <div class="flex gap-2 items-center">
                        <button
                            class="flex items-center"
                            (click)="handleUpdate()"
                        >
                            <app-icon name="material-symbols:edit" size="sm" />
                        </button>
                        <button
                            class="flex items-center"
                            (click)="handleDelete()"
                        >
                            <app-icon
                                name="material-symbols:cancel"
                                size="sm"
                            />
                        </button>
                    </div>
                }
            }
        </div>
    </div>
}
